import { useHistory } from 'react-router-dom'
import { useAppSelector, useUrlSearchParam } from '.'
import { eligibleUtilityProgramsCollection } from '@/reducers/eligibleUtilityPrograms'
import { useOnboardingResponses } from '@/app/hooks/useOnboardingResponses'
import useMultiProgramFlowControl from '@/hooks/useMultiProgramFlowControl'

export const useDeviceSelectionRedirectUrl = (goToSchedule?: boolean) => {
  const isPartner = useAppSelector((state) => state.auth.fromToken)
  const isMultiProgramPartner = useAppSelector(
    (state) => state.auth.fromMultiProgramPartner,
  )
  const onboardingResponses = useOnboardingResponses()
  const onboarding = useUrlSearchParam('onboarding')
  const { flowStartUrl, inFlow } = useMultiProgramFlowControl()
  const { data: eligiblePrograms } =
    eligibleUtilityProgramsCollection.useFetch()
  const selectedUtility = useAppSelector(
    (state) => state.utilities.selectedUtility,
  )

  if (isPartner && !isMultiProgramPartner) {
    return '/autogrid/success'
  }

  if (inFlow) {
    const multiProgramFlowStart = flowStartUrl
    if (multiProgramFlowStart) {
      return multiProgramFlowStart
    }
  }

  if (onboarding) {
    if (eligiblePrograms.length > 0 && selectedUtility) {
      return '/utility-program-enrollment'
    }

    if (onboardingResponses.hasThermostat) {
      return '/connect-device/thermostat'
    }

    if (!selectedUtility) {
      return '/connect-utility/information'
    }
  }

  if (onboarding && goToSchedule) {
    return '/devices?show-utility-enrollment=true'
  }

  return '/app'
}

// The onboarding destinations above can only be told apart once the eligible
// programs have loaded, so until then `useDeviceSelectionRedirectUrl` can hand
// back `/app` for a user who actually belongs on the enrollment page. Callers
// that navigate on a click don't need this — the click gives the fetch time to
// settle — but callers that navigate on their own do.
export const useDeviceSelectionRedirectUrlIsResolved = () => {
  const onboarding = useUrlSearchParam('onboarding')
  const { inFlow } = useMultiProgramFlowControl()
  const { isLoadingOrIdle } = eligibleUtilityProgramsCollection.useFetch()

  // In a multi-program flow the answer comes from persisted state, not a fetch.
  return inFlow || !onboarding || !isLoadingOrIdle
}

export const usePostAuthRedirectUrl = () => {
  const onboarding = useUrlSearchParam('onboarding')
  const currentPath = useHistory().location.pathname
  if (currentPath.includes('/ava/')) {
    if (onboarding) {
      return '/ava/onboarding/add-another'
    }
    return '/app'
  }

  return `/connect-vehicle/configure${onboarding ? '?onboarding=true' : ''}`
}
